import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isInternal } from "@/lib/analytics";

const visitorId = () => {
  let id = localStorage.getItem("mmp_vid");
  if (!id) {
    id = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("mmp_vid", id);
  }
  return id;
};

export function VisitTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const last = useRef(null);

  useEffect(() => {
    if (user === null || last.current === pathname) return;
    last.current = pathname;
    if (navigator.webdriver || isInternal() || user?.role === "admin" || pathname.startsWith("/admin")) return;
    api.post("/track/visit", { visitor_id: visitorId(), path: pathname, referrer: document.referrer || null })
      .then(({ data }) => {
        if (data.city) window.posthog?.register?.({ visitor_city: data.city, visitor_country: data.country, visitor_country_code: data.country_code });
      })
      .catch(() => {});
  }, [pathname, user]);

  return null;
}
